import React from 'react';

const baseClasses = 'card text-slate-900';

export const Card = React.forwardRef(function Card({ className = '', ...props }, ref) {
  const classes = [baseClasses, className].filter(Boolean).join(' ');
  return <div ref={ref} className={classes} {...props} />;
});

Card.displayName = 'Card';

export default Card;
